import { Grid } from '@material-ui/core';
import { getSoftwareSkills } from '@webapps/business';
import { useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Tooltip from 'components/Tooltip';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const Software = ({ info }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const userid = info?.id;

  const { data: softwareSkills = [] } = useQuery(getSoftwareSkills, {
    key: ['softwareSkills', userid],
    variables: { id: userid },
    enabled: typeof userid !== 'undefined',
  });

  const getLevelLabel = (level) => {
    if (level === 1) {
      return 'Débutant';
    }
    if (level === 2) {
      return 'Intermédiaire';
    }
    if (level === 3) {
      return 'Avancé';
    }
    if (level === 4) {
      return 'Confirmé';
    }
    return 'Non reconnu';
  };

  return (
    <div className={classes.container}>
      <div className={classes.editContainer}>
        <div className={cx(global.title, classes.title)}>
          <FormattedMessage id="student.profil.software.title" />
        </div>
      </div>
      {!softwareSkills?.length ? (
        <div
          className={cx(css({
            textAlign: 'center',
            marginTop: spacing(2),
          }), global.infoText)}
        >
          <FormattedMessage id="noElements" />
        </div>
      ) : (
        <Grid
          className={css({ marginTop: spacing(0.5) })}
          container
          spacing={2}
        >
          <Grid item xs={6} md={3}>
            <div style={{ color: '#5D75A8', marginBottom: spacing(1) }}>
              Nom
            </div>
            {softwareSkills?.map(({ label }, index) => (
              <div
                style={{ color: '#152652', marginBottom: spacing(1) }}
                key={index}
              >
                {label}
              </div>
            ))}
          </Grid>
          <Grid item xs={6} md={3}>
            <div style={{ color: '#5D75A8', marginBottom: spacing(1) }}>
              Niveau
            </div>
            {softwareSkills?.map(({ level }, index) => (
              <div
                style={{ color: '#152652', marginBottom: spacing(1) }}
                key={index}
              >
                {getLevelLabel(level)}
              </div>
            ))}
          </Grid>
        </Grid>
      )}
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    borderRadius: 10,
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
  },
  editContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    borderLeft: '3px solid #0060F9',
    lineHeight: '100%',
    paddingLeft: spacing(1),
    marginBottom: spacing(1.5),
  },
  button: {
    background: '#E5EFFF',
    color: '#152652',
    textAlign: 'center',
    padding: spacing(0.5),
    borderRadius: '10.0px',
  },
});

Software.propTypes = {
  info: PropTypes.object,
};

export default Software;
